var $12c0c13d1c959558$exports = {};
$12c0c13d1c959558$exports = {
    "pending": `pending`
};


export {$12c0c13d1c959558$exports as default};
//# sourceMappingURL=en-US.mjs.map
